<template>
  <v-row no-gutters>
    <!-- <v-col cols="12" md="4" :class="{ 'text-center': $vuetify.breakpoint.smAndDown }">
      <h2>{{ student.name }}</h2>
      <user-avatar-picker :student="student" />
    </v-col> -->

    <v-col cols="12">
      <v-data-table
        :dense="true"
        item-key="id"
        disableSort
        :headers="headers"
        :items="tableData"
        hide-default-footer
        :disable-pagination="true"
      >
        <template v-slot:no-data="">Chưa có lần bảo lưu nào </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-btn icon small @click.stop="onClickUpsertReservation(item)">
              <v-icon v-if="canEdit" small> mdi-pencil</v-icon>
              <v-icon v-else small> mdi-eye</v-icon>
            </v-btn>
            <v-btn v-if="canEdit" icon small @click.stop="onClickDeleteReservation(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.reason_type="{ value }">
          {{ getReasonTypeLabel(value) }}
        </template>
        <template v-slot:item.status="{ value }">
          {{ getReservationStatusLabel(value) }}
        </template>
        <template v-slot:item.tuition_status="{ value }">
          {{ getTuitionStatusLabel(value) }}
        </template>
        <template v-slot:top="">
          <div class="d-flex justify-space-between align-center">
            <p class="mb-0 font-weight-bold">Danh sách bảo lưu</p>
            <v-btn v-if="canEdit" elevation="0" color="primary" @click="onClickUpsertReservation()"
              >Tạo mới
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-col>

    <UpsertReservationDialog
      v-if="upsertReservationDialog.isOpen"
      :isOpen="upsertReservationDialog.isOpen"
      :isEdit="upsertReservationDialog.isEdit"
      :currentItem="upsertReservationDialog.currentItem"
      @close="upsertReservationDialog.onCancel"
      @cancel="upsertReservationDialog.onCancel"
      @confirm="upsertReservationDialog.callback"
      fixedStudent
    />
  </v-row>
</template>
<script>
import UpsertReservationDialog from '@/components/UpsertReservationDialog.vue'

import BaseDialog from '@/components/base/BaseDialog'
import { mapActions, mapState } from 'vuex'
import UserAvatarPicker from '@/components/basic/picker/UserAvatarPicker'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import DateSelector from '@/components/basic/DateSelector.vue'

import {
  getPaymentMethodOptions,
  getReasonTypeLabel,
  getReservationStatus,
  getReservationStatusLabel,
  getTuitionStatusLabel,
  reasonTypeOptions,
  transformDateForDatePicker,
  tuitionStatusOptions
} from '../../../helpers'

export default {
  computed: {
    ...mapState('reservation', ['reservations']),
    ...mapState('auth', ['profile', 'role']),
    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    },
    headers() {
      const output = [
        ...this.baseHeaders
        // ...(!this.canEdit ? [] : [{ text: 'Hành động', value: 'actions' }])
      ]
      return output
    },
    reasonTypeOptions,
    tuitionStatusOptions,
    getPaymentMethodOptions,
    studentId() {
      return this.$route.params.id
    },
    tableData() {
      return this.reservations.map((item, index) => {
        return {
          ...item,
          index: index + 1,
          status: getReservationStatus(item)
        }
      })
    }
  },
  components: {
    UpsertReservationDialog,
    DateSelector,
    UserAvatarPicker,
    BaseDialog
  },
  props: {
    student: Object
  },
  data() {
    return {
      baseHeaders: [
        { text: 'STT', align: 'left', value: 'index' },
        { text: 'Ngày hoàn thành thủ tục bảo lưu', value: 'process_completion_date' },
        { text: 'Ngày bắt đầu', value: 'start_date' },
        { text: 'Ngày kết thúc', value: 'end_date' },
        { text: 'Ngày dự kiến quay lại', value: 'return_date' },
        { text: 'Lí do', value: 'reason_type' },
        // { text: 'Lí do khác', value: 'reason' },
        // { text: 'Tình trạng học phí', value: 'tuition_status' },
        { text: 'Trạng thái', value: 'status' },
        { text: 'Hành động', value: 'actions' }
      ],
      tab: null,
      notes: '',
      loading: false,
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString(),
      upsertReservationDialog: {
        currentItem: null,
        isEdit: false,
        isOpen: false,
        callback: () => {},
        onCancel: () => {
          this.upsertReservationDialog.isOpen = false
          this.upsertReservationDialog.isEdit = false
          this.upsertReservationDialog.currentItem = null
        }
      }
    }
  },
  created() {
    // this.startDate = this.student.reservation.startDate || this.startDate
    // this.endDate = this.student.reservation.endDate || this.endDate
    // this.notes = this.student.reservation.notes || this.notes
    this.fetchReservations({ student: this.studentId })
  },
  methods: {
    ...mapActions('student', ['updateStudent']),
    ...mapActions('student', ['fetchStudent']),

    ...mapActions('reservation', [
      'fetchReservations',
      'createReservation',
      'updateReservation',
      'removeReservation'
    ]),
    getReservationStatusLabel,
    transformDateForDatePicker,
    getTuitionStatusLabel,
    getReasonTypeLabel,
    onClickDeleteReservation(item) {
      this.$dialog.confirm({
        title: 'Xóa bảo lưu',
        text: ` Bạn có Chắc Chắn xóa thông tin bảo lưu này?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          await this.removeReservation({ id: item.id })
          this.$alert.success('Xóa thành công')
          await this.fetchStudent(this.$route.params.id)
        }
      })
    },
    onCompletionDateChange(value) {
      this.upsertReservationDialog.currentItem.process_completion_date = moment(
        value,
        'YYYY-MM-DD'
      ).toISOString()
    },
    onStartDateChange(value) {
      this.upsertReservationDialog.currentItem.start_date = moment(
        value,
        'YYYY-MM-DD'
      ).toISOString()
    },
    onEndDateChange(value) {
      this.upsertReservationDialog.currentItem.end_date = moment(value, 'YYYY-MM-DD')
        .endOf('day')
        .toISOString()
    },
    onReturnDateChange(value) {
      this.upsertReservationDialog.currentItem.return_date = moment(value, 'YYYY-MM-DD')
        .endOf('day')
        .toISOString()
    },
    onNewClassDateChange(value) {
      this.upsertReservationDialog.currentItem.new_class_date = moment(value, 'YYYY-MM-DD')
        .endOf('day')
        .toISOString()
    },
    onClickUpsertReservation(item) {
      let data = {
        student: '',
        start_date: moment().startOf('day').toISOString(),
        end_date: undefined,
        process_completion_date: undefined,
        reason: '',
        note: '',
        reason_type: '',
        tuition_status: '',
        new_class: '',
        return_date: undefined,
        actual_return_date: undefined,
        new_class_date: undefined
      }
      if (item) {
        data = cloneDeep(item)
        data.student = data.student.id
      } else if (this.studentId) {
        data.student = this.studentId
      }
      this.upsertReservationDialog.currentItem = data
      this.upsertReservationDialog.isEdit = !!item
      this.upsertReservationDialog.isOpen = true
      this.upsertReservationDialog.callback = (async payload => {
        try {
          if (item) {
            await this.updateReservation({
              id: item.id,
              params: payload
            })
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createReservation({
              params: payload
            })
            this.$alert.success('Tạo thành công')
          }
          await this.fetchStudent(
            this.upsertReservationDialog.currentItem.student.id ||
              this.upsertReservationDialog.currentItem.student
          )
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertReservationDialog.isOpen = false
          this.upsertReservationDialog.currentItem = null
        }
      }).bind(this)
    },

    reset() {
      this.$refs.form.reset()
    },

    // async save() {
    //   if (!['super_admin', 'education_manager'].includes(this.role.type)) {
    //     return
    //   }
    //   this.loading = true
    //   await this.updateStudent({
    //     id: this.student.id,
    //     status: 'reserved',
    //     reservation: {
    //       notes: this.notes,
    //       startDate: this.startDate,
    //       endDate: this.endDate
    //     }
    //   })
    //   this.loading = false
    // },
    // async activeStudent() {
    //   this.loading = true
    //   await this.updateStudent({
    //     id: this.student.id,
    //     status: 'active'
    //   })
    //   this.loading = false
    // },
    updateStartDate(value) {
      this.startDate = value
    },
    updateEndDate(value) {
      this.endDate = value
    }
  }
}
</script>
